import { CheckOutlined, ContentCopy } from "@mui/icons-material";
import { Box, CardMedia, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  PromptData,
  SettingsData,
  VideoModalData,
} from "../../../../Types/VideoSuite-Types";
import { getSettingsData } from "./helper";

const sharedTypographyStyle = {
  fontFamily: "Roboto",
  fontSize: "14px",
  fontStyle: "normal",
  fontWight: 400,
};
const promptContainerStyle = {
  my: 2,
  p: "12px",
  borderRadius: "12px",
  height: "100px",
  overflowX: "hidden",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    display: "none", // Hide scrollbar if needed
  },
};
interface VideoDetailsCardProps {
  videoInput: PromptData;
  videoSettings: SettingsData;
}
const VideoDetailsCard = ({
  videoInput,
  videoSettings,
}: VideoDetailsCardProps) => {
  const [copied, setCopied] = useState(false);
  const settingsData = getSettingsData(videoSettings);
  const handleCopyPrompt = () => {
    if (!videoInput.prompt) return;
    setCopied(true);
    navigator.clipboard.writeText(videoInput.prompt);
    setTimeout(() => {
      setCopied(false);
    }, 800);
  };

  return (
    <Box
      className="video-details-card"
      sx={{
        p: 2,
        my: 0.5,
        borderRadius: "12px",
      }}
    >
      {/* attachment image */}
      {videoInput.attachment && (
        <Box>
          <Typography
            className="shared-typography-color"
            sx={sharedTypographyStyle}
          >
            Input image
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CardMedia
              component={"img"}
              alt="input image"
              image={videoInput.attachment}
              sx={{
                width: "160px",
                height: "177px",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      )}

      {/* prompt and details*/}
      <Box>
        {/* copy */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            className="shared-typography-color"
            sx={sharedTypographyStyle}
          >
            Prompt
          </Typography>

          <Box>
            {copied ? (
              <CheckOutlined
                sx={{
                  color: "#12B6EA",
                  fontSize: "18px",
                }}
              />
            ) : (
              <ContentCopy
                onClick={handleCopyPrompt}
                sx={{
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              />
            )}
          </Box>
        </Box>

        {/* prompt */}
        <Box className="prompt-container" sx={promptContainerStyle}>
          <Typography
            className="shared-typography-color"
            sx={{
              ...sharedTypographyStyle,
              fontWeight: 300,
              lineHeight: "25px",
            }}
          >
            {videoInput.prompt}
          </Typography>
        </Box>

        {/* details */}
        <Box>
          {settingsData.map((item, index) => (
            <Box
              sx={{
                my: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={sharedTypographyStyle}>{item?.title}</Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWight: 400,
                  opacity: 0.7,
                }}
              >
                {item?.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default VideoDetailsCard;
